import Phaser from "phaser";
import emitter from "../Events/EventManager";
import events from "../Events/Events";
import { gameVM } from "../Game.jsx";

//TC Version
import background from "../assets/game-background.png";
import timeFont from "../assets/game-timefont.png";
import scoreFont from "../assets/game-marksfont.png";
import timerBar from "../assets/game-timebar.png";
import gameScorebar from "../assets/game-marksbar.png";
import timeProgressbar from "../assets/game-timer.png";
import goToInstruction from "../assets/game-gameinfobutton.png";
import instruction from "../assets/info-palyinfo.png";
import understand from "../assets/game-gameinfobutton2.png";
import leftDoor from "../assets/game-Ldoor.png";
import leftDoorOpen from "../assets/game-Ldooropen.png";
import rightDoor from "../assets/game-Rdoor.png";
import rightDoorOpen from "../assets/game-Rdooropen.png";
import message_needExperience from "../assets/game-bosstalking.png";
import message_needIntern from "../assets/game-bosstalking2.png";
import message_correct from "../assets/game-bosstalkingright.png";
import message_incorrect from "../assets/game-bosstalkingwrong.png";
import message_incorrectExit from "../assets/game-bosstalkingwrongexit.png";

import boss from "../assets/game-boss.png";
import boss_correct from "../assets/game-bossright.png";
import boss_incorrect from "../assets/game-bosswrong.png";
import boss_incorrectExit from "../assets/game-bosswrongexit.png";

import boss2 from "../assets/game-boss2.png";
import boss2_correct from "../assets/game-bossright2.png";
import boss2_incorrect from "../assets/game-bosswrong2.png";
import boss2_incorrectExit from "../assets/game-bosswrongexit2.png";

import interviewer0 from "../assets/game-interviewer1.png";
import interviewer1 from "../assets/game-interviewer2.png";
import interviewer2 from "../assets/game-interviewer3.png";
import interviewer3 from "../assets/game-interviewer4.png";
import interviewer4 from "../assets/game-interviewer5.png";

import interviewer5 from "../assets/game-interviewer6.png";
import interviewer6 from "../assets/game-interviewer7.png";
import interviewer7 from "../assets/game-interviewer8.png";
import interviewer8 from "../assets/game-interviewer9.png";
import interviewer9 from "../assets/game-interviewer10.png";

import interviewer10 from "../assets/game-interviewer11.png";
import interviewer11 from "../assets/game-interviewer12.png";
import interviewer12 from "../assets/game-interviewer13.png";
import interviewer13 from "../assets/game-interviewer14.png";
import interviewer14 from "../assets/game-interviewer15.png";

import interviewer15 from "../assets/game-interviewer16.png";
import interviewer16 from "../assets/game-interviewer17.png";
import interviewer17 from "../assets/game-interviewer18.png";
import interviewer18 from "../assets/game-interviewer19.png";
import interviewer19 from "../assets/game-interviewer20.png";

import cvCover from "../assets/game-cvback.png";
import cvThumb0 from "../assets/game-cvinterviewericon1.png";
import cvThumb1 from "../assets/game-cvinterviewericon2.png";
import cvThumb2 from "../assets/game-cvinterviewericon3.png";
import cvThumb3 from "../assets/game-cvinterviewericon4.png";
import cvThumb4 from "../assets/game-cvinterviewericon5.png";

import cvThumb5 from "../assets/game-cvinterviewericon6.png";
import cvThumb6 from "../assets/game-cvinterviewericon7.png";
import cvThumb7 from "../assets/game-cvinterviewericon8.png";
import cvThumb8 from "../assets/game-cvinterviewericon9.png";
import cvThumb9 from "../assets/game-cvinterviewericon10.png";

import cvThumb10 from "../assets/game-cvinterviewericon11.png";
import cvThumb11 from "../assets/game-cvinterviewericon12.png";
import cvThumb12 from "../assets/game-cvinterviewericon13.png";
import cvThumb13 from "../assets/game-cvinterviewericon14.png";
import cvThumb14 from "../assets/game-cvinterviewericon15.png";

import cvThumb15 from "../assets/game-cvinterviewericon16.png";
import cvThumb16 from "../assets/game-cvinterviewericon17.png";
import cvThumb17 from "../assets/game-cvinterviewericon18.png";
import cvThumb18 from "../assets/game-cvinterviewericon19.png";
import cvThumb19 from "../assets/game-cvinterviewericon20.png";

import quitButton from "../assets/game-quitbutton.png";

import exit from "../assets/game-exitbutton.png";
import interviewButton from "../assets/game-interviewbutton.png";
import doorHint from "../assets/door-hints.png";
import bossBackground from "../assets/game-bossbackground.png";
import addScore from "../assets/game-pointadd.png";
import minusScore from "../assets/game-pointloss.png";
import correctDoor from "../assets/door-right.png";
import incorrectDoor from "../assets/door-wrong.png";
import gameinfoInGame from "../assets/info-gameinfo.png";

//EN Version
import backgroundEN from "../assets/EN/game-background.png";
import timeFontEN from "../assets/EN/game-timefont.png";
import scoreFontEN from "../assets/EN/game-marksfont.png";
import timerBarEN from "../assets/EN/game-timebar.png";
import gameScorebarEN from "../assets/EN/game-marksbar.png";
import timeProgressbarEN from "../assets/EN/game-timer.png";
import goToInstructionEN from "../assets/EN/game-gameinfobutton.png";
import instructionEN from "../assets/EN/info-palyinfo.png";
import understandEN from "../assets/EN/game-gameinfobutton2.png";
import leftDoorEN from "../assets/EN/game-Ldoor.png";
import leftDoorOpenEN from "../assets/EN/game-Ldooropen.png";
import rightDoorEN from "../assets/EN/game-Rdoor.png";
import rightDoorOpenEN from "../assets/EN/game-Rdooropen.png";
import message_needExperienceEN from "../assets/EN/game-bosstalking.png";
import message_needInternEN from "../assets/EN/game-bosstalking2.png";
import message_correctEN from "../assets/EN/game-bosstalkingright.png";
import message_incorrectEN from "../assets/EN/game-bosstalkingwrong.png";
import message_incorrectExitEN from "../assets/EN/game-bosstalkingwrongexit.png";

import bossEN from "../assets/EN/game-boss.png";
import boss_correctEN from "../assets/EN/game-bossright.png";
import boss_incorrectEN from "../assets/EN/game-bosswrong.png";
import boss_incorrectExitEN from "../assets/EN/game-bosswrongexit.png";

import boss2EN from "../assets/EN/game-boss2.png";
import boss2_correctEN from "../assets/EN/game-bossright2.png";
import boss2_incorrectEN from "../assets/EN/game-bosswrong2.png";
import boss2_incorrectExitEN from "../assets/EN/game-bosswrongexit2.png";

import interviewer0EN from "../assets/EN/game-interviewer1.png";
import interviewer1EN from "../assets/EN/game-interviewer2.png";
import interviewer2EN from "../assets/EN/game-interviewer3.png";
import interviewer3EN from "../assets/EN/game-interviewer4.png";
import interviewer4EN from "../assets/EN/game-interviewer5.png";

import interviewer5EN from "../assets/EN/game-interviewer6.png";
import interviewer6EN from "../assets/EN/game-interviewer7.png";
import interviewer7EN from "../assets/EN/game-interviewer8.png";
import interviewer8EN from "../assets/EN/game-interviewer9.png";
import interviewer9EN from "../assets/EN/game-interviewer10.png";

import interviewer10EN from "../assets/EN/game-interviewer11.png";
import interviewer11EN from "../assets/EN/game-interviewer12.png";
import interviewer12EN from "../assets/EN/game-interviewer13.png";
import interviewer13EN from "../assets/EN/game-interviewer14.png";
import interviewer14EN from "../assets/EN/game-interviewer15.png";

import interviewer15EN from "../assets/EN/game-interviewer16.png";
import interviewer16EN from "../assets/EN/game-interviewer17.png";
import interviewer17EN from "../assets/EN/game-interviewer18.png";
import interviewer18EN from "../assets/EN/game-interviewer19.png";
import interviewer19EN from "../assets/EN/game-interviewer20.png";

import cvCoverEN from "../assets/EN/game-cvback.png";
import cvThumb0EN from "../assets/EN/game-cvinterviewericon1.png";
import cvThumb1EN from "../assets/EN/game-cvinterviewericon2.png";
import cvThumb2EN from "../assets/EN/game-cvinterviewericon3.png";
import cvThumb3EN from "../assets/EN/game-cvinterviewericon4.png";
import cvThumb4EN from "../assets/EN/game-cvinterviewericon5.png";

import cvThumb5EN from "../assets/EN/game-cvinterviewericon6.png";
import cvThumb6EN from "../assets/EN/game-cvinterviewericon7.png";
import cvThumb7EN from "../assets/EN/game-cvinterviewericon8.png";
import cvThumb8EN from "../assets/EN/game-cvinterviewericon9.png";
import cvThumb9EN from "../assets/EN/game-cvinterviewericon10.png";

import cvThumb10EN from "../assets/EN/game-cvinterviewericon11.png";
import cvThumb11EN from "../assets/EN/game-cvinterviewericon12.png";
import cvThumb12EN from "../assets/EN/game-cvinterviewericon13.png";
import cvThumb13EN from "../assets/EN/game-cvinterviewericon14.png";
import cvThumb14EN from "../assets/EN/game-cvinterviewericon15.png";

import cvThumb15EN from "../assets/EN/game-cvinterviewericon16.png";
import cvThumb16EN from "../assets/EN/game-cvinterviewericon17.png";
import cvThumb17EN from "../assets/EN/game-cvinterviewericon18.png";
import cvThumb18EN from "../assets/EN/game-cvinterviewericon19.png";
import cvThumb19EN from "../assets/EN/game-cvinterviewericon20.png";

import quitButtonEN from "../assets/EN/game-quitbutton.png";

import exitEN from "../assets/EN/game-exitbutton.png";
import interviewButtonEN from "../assets/EN/game-interviewbutton.png";
import doorHintEN from "../assets/EN/door-hints.png";
import bossBackgroundEN from "../assets/EN/game-bossbackground.png";
import addScoreEN from "../assets/EN/game-pointadd.png";
import minusScoreEN from "../assets/EN/game-pointloss.png";
import correctDoorEN from "../assets/EN/door-right.png";
import incorrectDoorEN from "../assets/EN/door-wrong.png";
import gameinfoInGameEN from "../assets/EN/info-gameinfo.png";

// SC Version

import backgroundSC from "../assets/SC/game-background.png";
import timeFontSC from "../assets/SC/game-timefont.png";
import scoreFontSC from "../assets/SC/game-marksfont.png";
import timerBarSC from "../assets/SC/game-timebar.png";
import gameScorebarSC from "../assets/SC/game-marksbar.png";
import timeProgressbarSC from "../assets/SC/game-timer.png";
import goToInstructionSC from "../assets/SC/game-gameinfobutton.png";
import instructionSC from "../assets/SC/info-palyinfo.png";
import understandSC from "../assets/SC/game-gameinfobutton2.png";
import leftDoorSC from "../assets/SC/game-Ldoor.png";
import leftDoorOpenSC from "../assets/SC/game-Ldooropen.png";
import rightDoorSC from "../assets/SC/game-Rdoor.png";
import rightDoorOpenSC from "../assets/SC/game-Rdooropen.png";
import message_needExperienceSC from "../assets/SC/game-bosstalking.png";
import message_needInternSC from "../assets/SC/game-bosstalking2.png";
import message_correctSC from "../assets/SC/game-bosstalkingright.png";
import message_incorrectSC from "../assets/SC/game-bosstalkingwrong.png";
import message_incorrectExitSC from "../assets/SC/game-bosstalkingwrongexit.png";

import bossSC from "../assets/SC/game-boss.png";
import boss_correctSC from "../assets/SC/game-bossright.png";
import boss_incorrectSC from "../assets/SC/game-bosswrong.png";
import boss_incorrectExitSC from "../assets/SC/game-bosswrongexit.png";

import boss2SC from "../assets/SC/game-boss2.png";
import boss2_correctSC from "../assets/SC/game-bossright2.png";
import boss2_incorrectSC from "../assets/SC/game-bosswrong2.png";
import boss2_incorrectExitSC from "../assets/SC/game-bosswrongexit2.png";

import interviewer0SC from "../assets/SC/game-interviewer1.png";
import interviewer1SC from "../assets/SC/game-interviewer2.png";
import interviewer2SC from "../assets/SC/game-interviewer3.png";
import interviewer3SC from "../assets/SC/game-interviewer4.png";
import interviewer4SC from "../assets/SC/game-interviewer5.png";

import interviewer5SC from "../assets/SC/game-interviewer6.png";
import interviewer6SC from "../assets/SC/game-interviewer7.png";
import interviewer7SC from "../assets/SC/game-interviewer8.png";
import interviewer8SC from "../assets/SC/game-interviewer9.png";
import interviewer9SC from "../assets/SC/game-interviewer10.png";

import interviewer10SC from "../assets/SC/game-interviewer11.png";
import interviewer11SC from "../assets/SC/game-interviewer12.png";
import interviewer12SC from "../assets/SC/game-interviewer13.png";
import interviewer13SC from "../assets/SC/game-interviewer14.png";
import interviewer14SC from "../assets/SC/game-interviewer15.png";

import interviewer15SC from "../assets/SC/game-interviewer16.png";
import interviewer16SC from "../assets/SC/game-interviewer17.png";
import interviewer17SC from "../assets/SC/game-interviewer18.png";
import interviewer18SC from "../assets/SC/game-interviewer19.png";
import interviewer19SC from "../assets/SC/game-interviewer20.png";

import cvCoverSC from "../assets/SC/game-cvback.png";
import cvThumb0SC from "../assets/SC/game-cvinterviewericon1.png";
import cvThumb1SC from "../assets/SC/game-cvinterviewericon2.png";
import cvThumb2SC from "../assets/SC/game-cvinterviewericon3.png";
import cvThumb3SC from "../assets/SC/game-cvinterviewericon4.png";
import cvThumb4SC from "../assets/SC/game-cvinterviewericon5.png";

import cvThumb5SC from "../assets/SC/game-cvinterviewericon6.png";
import cvThumb6SC from "../assets/SC/game-cvinterviewericon7.png";
import cvThumb7SC from "../assets/SC/game-cvinterviewericon8.png";
import cvThumb8SC from "../assets/SC/game-cvinterviewericon9.png";
import cvThumb9SC from "../assets/SC/game-cvinterviewericon10.png";

import cvThumb10SC from "../assets/SC/game-cvinterviewericon11.png";
import cvThumb11SC from "../assets/SC/game-cvinterviewericon12.png";
import cvThumb12SC from "../assets/SC/game-cvinterviewericon13.png";
import cvThumb13SC from "../assets/SC/game-cvinterviewericon14.png";
import cvThumb14SC from "../assets/SC/game-cvinterviewericon15.png";

import cvThumb15SC from "../assets/SC/game-cvinterviewericon16.png";
import cvThumb16SC from "../assets/SC/game-cvinterviewericon17.png";
import cvThumb17SC from "../assets/SC/game-cvinterviewericon18.png";
import cvThumb18SC from "../assets/SC/game-cvinterviewericon19.png";
import cvThumb19SC from "../assets/SC/game-cvinterviewericon20.png";

import quitButtonSC from "../assets/SC/game-quitbutton.png";

import exitSC from "../assets/SC/game-exitbutton.png";
import interviewButtonSC from "../assets/SC/game-interviewbutton.png";
import doorHintSC from "../assets/SC/door-hints.png";
import bossBackgroundSC from "../assets/SC/game-bossbackground.png";
import addScoreSC from "../assets/SC/game-pointadd.png";
import minusScoreSC from "../assets/SC/game-pointloss.png";
import correctDoorSC from "../assets/SC/door-right.png";
import incorrectDoorSC from "../assets/SC/door-wrong.png";

import gameinfoInGameSC from "../assets/SC/info-gameinfo.png";

import { dispatchUpdateCurrentQuestion } from "../reducers/sceneReducer";

import GameflowHelper from "../Helpers/GameflowHelper";
import {
  QUESTION_IS_RANDOM,
  QUESTION_START_WITH,
  QUESTION_END_WITH,
} from "../Config/data";

export default class Scene3ViewModel {
  currentScene;
  timeRemaining;
  question;
  questions;
  fontStyle;
  fontStyleLarge;
  currentQuestionIndex;
  _currentQuestion;
  get currentQuestion() {
    return this._currentQuestion;
  }
  set currentQuestion(val) {
    dispatchUpdateCurrentQuestion(val);
    this._currentQuestion = val;
  }
  score;
  leftInterviewerAnswer;
  rightInterviewerAnswer;
  currentSelectedInterviewer;
  leftInterviewerHasBeenSelected;
  rightInterviewerHasBeenSelected;
  randomIndexOfQuestions;
  timeRemaining;
  currentLeftInterviewerIndex;
  currentRightInterviewerIndex;

  constructor(scene3) {
    this.currentScene = scene3;
    this.timeRemaining = gameVM.gameTotalTime;

    this.fontStyle = {
      font: "39px DFFN_6",
      fill: "#000000",
      wordWrap: { width: 350, useAdvancedWrap: true },
    };
    this.fontStyleLarge = {
      font: "60px DFFN_6",
      fill: "#000000",
      wordWrap: { width: 350, useAdvancedWrap: true },
    };

    this.enfontStyle = {
      font: "34px DFFN_6",
      fill: "#000000",
      wordWrap: { width: 340, useAdvancedWrap: true },
    };

    this.enfontStyleLarge = {
      font: "50px DFFN_6",
      fill: "#000000",
      wordWrap: { width: 340, useAdvancedWrap: true },
    };

    this.scfontStyle = {
      font: "34px DFPLiJinHeiW8",
      fill: "#000000",
      wordWrap: { width: 340, useAdvancedWrap: true },
    };

    this.scfontStyleLarge = {
      font: "50px DFPLiJinHeiW8",
      fill: "#000000",
      wordWrap: { width: 340, useAdvancedWrap: true },
    };

    this.score = 0;
    this.randomIndexOfQuestions = this.generateRandomIndex(QUESTION_IS_RANDOM).slice(
      QUESTION_START_WITH - 1,
      QUESTION_END_WITH
    );
    if (gameVM.language == null) {
      this.questions = this.randomIndexOfQuestions.map(
        (index) => gameVM.questions[index]
      );
    }
    if (gameVM.language == "EN") {
      this.questions = this.randomIndexOfQuestions.map(
        (index) => gameVM.questions_en[index]
      );
    }
    if (gameVM.language == "SC") {
      this.questions = this.randomIndexOfQuestions.map(
        (index) => gameVM.questions_sc[index]
      );
    }

    this.currentQuestionIndex = 0;
    this.currentQuestion = this.questions[this.currentQuestionIndex];

    this.leftInterviewerHasBeenSelected = false;
    this.rightInterviewerHasBeenSelected = false;
  }

  timeProgressbarSetProgress(proportion) {
    this.currentScene.timeProgressbar.setCrop(0, 0, proportion * 350, 100);
  }

  addText(...args) {
    //args:[left, top, string, fontOption(0 is smaller, 1 bigger, 2 is smaller EN, 2 is bigger EN)]
    if (args[3] === 0) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.fontStyle)
        .setOrigin(0, 0);
    }

    if (args[3] === 1) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.fontStyleLarge)
        .setOrigin(0, 0);
    }

    if (args[3] === 2) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.enfontStyle)
        .setOrigin(0, 0);
    }

    if (args[3] === 3) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.enfontStyleLarge)
        .setOrigin(0, 0);
    }

    if (args[3] === 4) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.scfontStyle)
        .setOrigin(0, 0);
    }

    if (args[3] === 5) {
      return this.currentScene.add
        .text(args[0], args[1], args[2], this.scfontStyleLarge)
        .setOrigin(0, 0);
    }
  }

  showCVText(leftPixel, description) {
    const increment = -75;
    let textContainer = this.currentScene.add.container(0, 0);
    if (gameVM.language == null) {
      if (description.internship != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, "實習期：", 0)
        );
        textContainer.add(
          this.addText(leftPixel, 0.82 * 1080 + increment - 20, description.internship, 1)
        );
        textContainer.add(
          this.addText(leftPixel, 0.89 * 1080 + increment - 25, description.more, 0)
        );
      }

      if (description.age != null) {
        textContainer.add(
          this.addText(leftPixel, 0.82 * 1080 + increment, "年齡：" + description.age, 1)
        );
      }

      if (description.organization != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.organization, 0)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.authorized, 1)
        );
      }

      if (description.course != null) {
        textContainer.add(
          this.addText(leftPixel, 0.8 * 1080 + increment, description.course, 0)
        );
      }

      if (description.relatedOrNot != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.relatedOrNot, 0)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.related, 1)
        );
      }

      if (description.contract != null) {
        textContainer.add(
          this.addText(leftPixel, 0.78 * 1080 + increment, description.contract, 0)
        );
      }

      if (description.agreement != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.agreement, 0)
        );
      }
    } else if (gameVM.language == "EN") {
      //EN Version ===================================
      if (description.internship != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, "Duration of internship", 2)
        );
        textContainer.add(
          this.addText(leftPixel, 0.81 * 1080 + increment - 20, description.internship, 3)
        );
        textContainer.add(
          this.addText(leftPixel, 0.865 * 1080 + increment - 25, description.more, 2)
        );
      }

      if (description.age != null) {
        textContainer.add(
          this.addText(leftPixel, 0.82 * 1080 + increment, "Age: " + description.age, 3)
        );
      }

      if (description.organization != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.organization, 2)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.authorized, 3)
        );
      }

      if (description.course != null) {
        textContainer.add(
          this.addText(leftPixel, 0.8 * 1080 + increment, description.course, 2)
        );
      }

      if (description.relatedOrNot != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.relatedOrNot, 2)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.related, 3)
        );
      }

      if (description.contract != null) {
        textContainer.add(
          this.addText(leftPixel, 0.78 * 1080 + increment, description.contract, 2)
        );
      }

      if (description.agreement != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.agreement, 2)
        );
      }
    } else if (gameVM.language == "SC") {
      if (description.internship != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, "实习期：", 4)
        );
        textContainer.add(
          this.addText(leftPixel, 0.82 * 1080 + increment - 20, description.internship, 5)
        );
        textContainer.add(
          this.addText(leftPixel, 0.89 * 1080 + increment - 25, description.more, 4)
        );
      }

      if (description.age != null) {
        textContainer.add(
          this.addText(leftPixel, 0.82 * 1080 + increment, "年龄：" + description.age, 5)
        );
      }

      if (description.organization != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.organization, 4)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.authorized, 5)
        );
      }

      if (description.course != null) {
        textContainer.add(
          this.addText(leftPixel, 0.8 * 1080 + increment, description.course, 4)
        );
      }

      if (description.relatedOrNot != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.relatedOrNot, 4)
        );
        textContainer.add(
          this.addText(leftPixel, 0.88 * 1080 + increment, description.related, 5)
        );
      }

      if (description.contract != null) {
        textContainer.add(
          this.addText(leftPixel, 0.78 * 1080 + increment, description.contract, 4)
        );
      }

      if (description.agreement != null) {
        textContainer.add(
          this.addText(leftPixel, 0.76 * 1080 + increment, description.agreement, 4)
        );
      }
    }

    return textContainer;
  }

  showCVTextLeft(description) {
    return this.showCVText(70, description);
  }

  showCVTextRight(description) {
    return this.showCVText(610, description);
  }

  messageSetInvisible() {
    this.currentScene.message_needExperience.visible = false;
    this.currentScene.message_needIntern.visible = false;
    this.currentScene.message_correct.visible = false;
    this.currentScene.message_incorrect.visible = false;
    this.currentScene.message_incorrectExit.visible = false;
  }

  showInterviewers() {
    this.currentScene.leftInterviewer.visible = true;
    this.currentScene.rightInterviewer.visible = true;
  }

  hideLeftCV() {
    this.currentScene.leftCV.visible = false;
  }

  hideRightCV() {
    this.currentScene.rightCV.visible = false;
  }

  openInstruction() {
    this.currentScene.whiteTransparentCover = this.currentScene.graphics = this.currentScene.add.graphics(
      {
        fillStyle: { color: "#000000" },
      }
    );
    this.currentScene.sound.play("clickSound");
    this.currentScene.graphics.alpha = 0.5;
    this.currentScene.graphics.fillRect(0, 0, 1920, 1080);

    this.currentScene.instruction = this.currentScene.add.image(
      1920 / 2,
      0.43 * 1080,
      "gameinfoInGame"
    );

    this.currentScene.understand = this.currentScene.add
      .image(1920 / 2, 0.825 * 1080, "understand")
      .setInteractive({ cursor: "pointer" });

    this.currentScene.understand.on("pointerup", this.closeInstruction, this);

    this.currentScene.goToInstructionButton.disableInteractive();
    this.currentScene.time.paused = true;

    this.currentScene.leftInterview.disableInteractive();
    this.currentScene.rightInterview.disableInteractive();
    this.currentScene.leftExit.disableInteractive();
    this.currentScene.rightExit.disableInteractive();
    this.currentScene.quitButton.disableInteractive();
  }

  closeInstruction(pointer) {
    this.currentScene.sound.play("clickSound");
    this.currentScene.whiteTransparentCover.destroy();
    this.currentScene.instruction.destroy();
    this.currentScene.understand.destroy();
    this.currentScene.time.paused = false;
    this.currentScene.goToInstructionButton.setInteractive();

    this.currentScene.leftInterview.setInteractive();
    this.currentScene.leftExit.setInteractive();
    this.currentScene.rightInterview.setInteractive();
    this.currentScene.rightExit.setInteractive();
    this.currentScene.quitButton.setInteractive();
  }

  saveStateToGameVM() {
    gameVM.latestScore = this.score;
    gameVM.timeRemaining = this.timeRemaining;
  }

  startEndingScene() {
    gameVM.prevScene = this.currentScene;
    emitter.removeListener(events.addScore);
    emitter.removeListener(events.minusScore);
    this.currentScene.quitButton.disableInteractive();
    this.currentScene.scene.launch("Ending");
  }

  showMessage(string) {
    if (string === "correct") {
      this.messageSetInvisible();
      this.currentScene.message_correct.visible = true;
      this.fadeIn(this.currentScene.message_correct);
    } else if (string === "incorrect") {
      this.messageSetInvisible();
      this.currentScene.message_incorrect.visible = true;
      this.fadeIn(this.currentScene.message_incorrect);
    } else if (string === "incorrectExit") {
      this.messageSetInvisible();
      this.currentScene.message_incorrectExit.visible = true;
      this.fadeIn(this.currentScene.message_incorrectExit);
    } else if (string === "experience") {
      this.messageSetInvisible();
      this.currentScene.message_needExperience.visible = true;
      this.fadeIn(this.currentScene.message_needExperience);
    } else if (string === "intern") {
      this.messageSetInvisible();
      this.currentScene.message_needIntern.visible = true;
      this.fadeIn(this.currentScene.message_needIntern);
    } else {
      this.messageSetInvisible();
    }
  }

  fadeIn(gameObj) {
    this.currentScene.tweens.add({
      targets: gameObj,
      alpha: { from: 0, to: 1 },
      duration: 450,
    });
  }

  showBoss(string) {
    this.bossSetInvisible();
    this.boss2SetInvisible();

    if (this.currentQuestion.question == "experience") {
      if (string === "correct") {
        this.bossSetInvisible();
        this.currentScene.boss_correct.visible = true;
      } else if (string === "incorrect") {
        this.bossSetInvisible();
        this.currentScene.boss_incorrect.visible = true;
      } else if (string === "incorrectExit") {
        this.bossSetInvisible();
        this.currentScene.boss_incorrectExit.visible = true;
      } else {
        this.bossSetInvisible();
        this.currentScene.boss.visible = true;
      }
    } else if (this.currentQuestion.question == "intern") {
      if (string === "correct") {
        this.boss2SetInvisible();
        this.currentScene.boss2_correct.visible = true;
      } else if (string === "incorrect") {
        this.boss2SetInvisible();
        this.currentScene.boss2_incorrect.visible = true;
      } else if (string === "incorrectExit") {
        this.boss2SetInvisible();
        this.currentScene.boss2_incorrectExit.visible = true;
      } else {
        this.boss2SetInvisible();
        this.currentScene.boss2.visible = true;
      }
    }
  }

  bossSetInvisible() {
    this.currentScene.boss.visible = false;
    this.currentScene.boss_correct.visible = false;
    this.currentScene.boss_incorrect.visible = false;
    this.currentScene.boss_incorrectExit.visible = false;
  }

  boss2SetInvisible() {
    this.currentScene.boss2.visible = false;
    this.currentScene.boss2_correct.visible = false;
    this.currentScene.boss2_incorrect.visible = false;
    this.currentScene.boss2_incorrectExit.visible = false;
  }

  showDoorHint(string) {
    this.currentScene.doorHintLeft.visible = false;
    this.currentScene.doorHintRight.visible = false;
    if (string === "intern") {
      this.currentScene.doorHintLeft.visible = true;
    }
    if (string === "experience") {
      this.currentScene.doorHintRight.visible = true;
    }
  }

  dimDoorAsHint(string) {
    this.currentScene.leftDoorClosed.alpha = 1;
    this.currentScene.rightDoorClosed.alpha = 1;
    if (string == "intern") {
      this.currentScene.tweens.add({
        targets: this.currentScene.rightDoorClosed,
        ease: "Cubic",
        alpha: { from: 1, to: 0.3 },
        duration: 500,
      });
    }
    if (string == "experience") {
      this.currentScene.tweens.add({
        targets: this.currentScene.leftDoorClosed,
        ease: "Cubic",
        alpha: { from: 1, to: 0.3 },
        duration: 500,
      });
    }
  }

  showPointerXYonClick() {
    this.currentScene.input.on("pointerup", (pointer) => {});
  }

  leftInterviewerIsSuitable() {
    return this.currentQuestion.left;
  }

  rightInterviewerIsSuitable() {
    return this.currentQuestion.right;
  }

  closeLeftCV() {
    this.currentScene.tweens.add({
      targets: this.currentScene.leftCV,
      alpha: 0,
      ease: "Cubic",
      duration: 400,
    });
  }

  async leftInterviewerGoLeft() {
    this.closeLeftCV();
    return new Promise((resolve, reject) => {
      this.currentScene.tweens.add({
        duration: 500,
        targets: this.currentScene.leftInterviewer,
        ease: "Cubic",
        x: 0.68 * 1920,
        y: 0.4 * 1080,
        onComplete: () => {
          this.currentScene.leftInterviewer.scaleX = -1;

          this.leftInterviewerAnswer = "intern";
          resolve(true);
        },
      });
    });
  }

  async leftInterviewerGoRight() {
    this.closeLeftCV();

    return new Promise((resolve, reject) => {
      this.currentScene.tweens.add({
        duration: 500,
        targets: this.currentScene.leftInterviewer,
        ease: "Cubic",
        x: 0.9 * 1920,
        y: 0.4 * 1080,
        onComplete: () => {
          this.currentScene.leftInterviewer.scaleX = -1;
          this.leftInterviewerAnswer = "experience";
          resolve(true);
        },
      });
    });
  }

  closeRightCV() {
    this.currentScene.tweens.add({
      targets: this.currentScene.rightCV,
      alpha: 0,
      ease: "Cubic",
      duration: 400,
    });
  }

  async rightInterviewerGoLeft() {
    this.closeRightCV();
    return new Promise((resolve, reject) => {
      this.currentScene.tweens.add({
        duration: 500,
        targets: this.currentScene.rightInterviewer,
        ease: "Cubic",
        x: 0.68 * 1920,
        y: 0.4 * 1080,
        onComplete: () => {
          this.currentScene.rightInterviewer.scaleX = -1;
          this.rightInterviewerAnswer = "experience";
          resolve(true);
        },
      });
    });
  }

  async rightInterviewerGoRight() {
    this.closeRightCV();
    return new Promise((resolve, reject) => {
      this.currentScene.tweens.add({
        duration: 500,
        targets: this.currentScene.rightInterviewer,
        ease: "Cubic",
        x: 0.9 * 1920,
        y: 0.4 * 1080,
        onComplete: () => {
          this.currentScene.rightInterviewer.scaleX = -1;
          this.rightInterviewerAnswer = "experience";
          resolve(true);
        },
      });
    });
  }

  fadeoutOrGoIn() {
    if (this.currentSelectedInterviewer === "left") {
      if (this.leftInterviewerIsSuitable()) {
        this.currentScene.leftInterviewerTweens = this.currentScene.tweens.add({
          targets: this.currentScene.leftInterviewer,
          x: "-=200",
          alpha: 0,
          duration: 500,
          onComplete: () => {
            emitter.emit(events.interviewerLeft);
          },
        });
      } else {
        this.quitSceneToRight(this.currentScene.leftInterviewer);
      }
    } else if (this.currentSelectedInterviewer === "right") {
      if (this.rightInterviewerIsSuitable()) {
        if (this.rightInterviewerIsSuitable) {
          this.currentScene.rightInterviewerTweens = this.currentScene.tweens.add({
            targets: this.currentScene.rightInterviewer,
            x: "-=200",
            alpha: 0,
            duration: 500,
            onComplete: () => {
              emitter.emit(events.interviewerLeft);
            },
          });
        }
      } else {
        this.quitSceneToRight(this.currentScene.rightInterviewer);
      }
    }
  }

  stopInterviewerTweens() {
    if (this.currentScene.leftInterviewerTweens) {
      this.currentScene.leftInterviewerTweens.stop();
    }
    if (this.currentScene.rightInterviewerTweens) {
      this.currentScene.rightInterviewerTweens.stop();
    }
  }

  quitSceneToRight(obj) {
    obj.scaleX = 1;
    this.currentScene.tweens.add({
      targets: obj,
      x: 2100,
      duration: 500,
      alpha: 0,
      onComplete: () => {
        emitter.emit(events.interviewerLeft);
      },
    });
  }

  quitSceneToLeft(obj) {
    obj.scaleX = -1;
    this.currentScene.tweens.add({
      targets: obj,
      x: -300,
      duration: 500,
      alpha: 0,
      onComplete: () => {
        emitter.emit(events.interviewerLeft);
      },
    });
  }

  Action(func, lastFor) {
    return new Promise((resolve, reject) => {
      func();
      setTimeout(() => {
        resolve(true);
      }, lastFor);
    });
  }

  showCVs() {
    this.currentScene.leftCV.alpha = 1;
    this.currentScene.rightCV.alpha = 1;
    this.currentScene.leftCV.visible = true;
    this.currentScene.rightCV.visible = true;
  }

  removeAllDoorIndicator() {
    if (this.currentScene.leftDoorCorrectIndicator) {
      this.currentScene.leftDoorCorrectIndicator.visible = false;
    }
    if (this.currentScene.leftDoorIncorrectIndicator) {
      this.currentScene.leftDoorIncorrectIndicator.visible = false;
    }
    if (this.currentScene.rightDoorCorrectIndicator) {
      this.currentScene.rightDoorCorrectIndicator.visible = false;
    }
    if (this.currentScene.rightDoorIncorrectIndicator) {
      this.currentScene.rightDoorIncorrectIndicator.visible = false;
    }
  }

  showCorrectDoorIndicatorLHS() {
    // this.currentScene.add.image(0.775 * 1920, 387, "rightDoor");
    this.removeAllDoorIndicator();
    this.currentScene.leftDoorCorrectIndicator.visible = true;
    this.sparkAnimation(this.currentScene.leftDoorCorrectIndicator);
  }

  showCorrectDoorIndicatorRHS() {
    this.removeAllDoorIndicator();
    this.currentScene.rightDoorCorrectIndicator.visible = true;
    this.sparkAnimation(this.currentScene.rightDoorCorrectIndicator);
  }

  showIncorrectDoorIndicatorLHS() {
    this.removeAllDoorIndicator();
    this.currentScene.leftDoorIncorrectIndicator.visible = true;
    this.sparkAnimation(this.currentScene.leftDoorIncorrectIndicator);
  }
  showIncorrectDoorIndicatorRHS() {
    this.removeAllDoorIndicator();
    this.currentScene.rightDoorIncorrectIndicator.visible = true;
    this.sparkAnimation(this.currentScene.rightDoorIncorrectIndicator);
  }

  sparkAnimation(obj) {
    this.currentScene.tweens.add({
      targets: obj,
      duration: 200,
      alpha: { from: 0, to: 1 },
      yoyo: true,
      repeat: 1,
    });
  }

  closeLeftDoor() {
    this.currentScene.leftDoorClosed.visible = true;
    this.currentScene.leftDoorOpen.visible = false;
  }

  closeRightDoor() {
    this.currentScene.rightDoorClosed.visible = true;
    this.currentScene.rightDoorOpen.visible = false;
  }

  closeDoors() {
    this.closeLeftDoor();
    this.closeRightDoor();
  }

  openLeftDoor() {
    this.currentScene.leftDoorOpen.visible = true;
    this.currentScene.leftDoorClosed.visible = false;
  }

  openRightDoor() {
    this.currentScene.rightDoorOpen.visible = true;
    this.currentScene.rightDoorClosed.visible = false;
  }

  openDoor() {
    if (this.currentQuestion.question === "intern") {
      this.openLeftDoor();
    } else {
      this.openRightDoor();
    }
  }

  restoreInterviewers() {
    [
      this.currentScene.leftInterviewer.x,
      this.currentScene.leftInterviewer.y,
    ] = this.leftInterviewerOriginalPosition;

    [
      this.currentScene.rightInterviewer.x,
      this.currentScene.rightInterviewer.y,
    ] = this.rightInterviewerOriginalPosition;

    this.currentScene.leftInterviewer.alpha = 1;
    this.currentScene.rightInterviewer.alpha = 1;

    this.currentScene.leftInterviewer.scaleX = 1;
    this.currentScene.rightInterviewer.scaleX = 1;
    this.currentScene.leftInterviewer.visible = true;
    this.currentScene.rightInterviewer.visible = true;
  }

  generateRandomIndex(random) {
    if (random) {
      const length = gameVM.questions.length;
      let array = [];
      for (let i = 0; i < length; i++) {
        array.push(i);
      }

      const newArray = [];

      while (newArray.length !== length) {
        const indexToTakeout = Math.floor((length - newArray.length) * Math.random());
        const NumberToTakeout = array[indexToTakeout];
        array = array.filter((number) => {
          return number !== NumberToTakeout;
        });
        newArray.push(NumberToTakeout);
      }

      return newArray;
    } else {
      const length = gameVM.questions.length;
      let array = [];
      for (let i = 0; i < length; i++) {
        array.push(i);
      }
      return array;
    }
    // return array;
  }

  createCVText() {
    this.currentScene.leftCVText = this.showCVTextLeft(
      this.currentQuestion.left_description
    );
    if (this.currentScene.leftCV !== null) {
      this.currentScene.leftCV.add(this.currentScene.leftCVText);
    }

    this.currentScene.rightCVText = this.showCVTextRight(
      this.currentQuestion.right_description
    );

    if (this.currentScene.rightCV != null) {
      this.currentScene.rightCV.add(this.currentScene.rightCVText);
    }
  }

  removeCVText() {
    this.currentScene.leftCVText.destroy();
    this.currentScene.rightCVText.destroy();
  }

  addScoreAnimation() {
    this.fadeoutMoveUp(this.currentScene.add.image(440, 200, "addScore"));
  }

  minusScoreAnimation() {
    this.fadeoutMoveUp(this.currentScene.add.image(440, 200, "minusScore"));
  }

  async fadeoutMoveUp(obj) {
    this.currentScene.tweens.add({
      targets: obj,
      duration: 1500,
      ease: "Cubic",
      y: 0,
      alpha: { from: 1, to: 0 },
    });

    GameflowHelper.action(() => {
      this.currentScene.tweens.add({
        targets: obj,
        duration: 200,
        ease: "Cubic",
        scaleX: 5,
        scaleY: 5,
      });
    }, 200).then(() => {
      this.currentScene.tweens.add({
        targets: obj,
        duration: 1000,
        ease: "Linear",
        scaleX: 1,
        scaleY: 1,
      });
    });
  }

  updateScoreText(number) {
    if (this.currentScene.scoreText) this.currentScene.scoreText.setText(number);
  }

  getRandomPair(number) {
    // random pair of distinct integers take from 0, ..., number - 1
    let integers = [];
    for (let i = 0; i < number; i++) {
      integers.push(i);
    }

    const firstNumber = Math.floor(number * Math.random());
    integers = integers.filter((n) => n !== firstNumber);

    const secondIndex = Math.floor((number - 1) * Math.random());
    const secondNumber = integers[secondIndex];

    return [firstNumber, secondNumber];
  }

  updateInterviewers() {
    this.currentScene.leftInterviewer.setTexture(
      "interviewer" + this.currentLeftInterviewerIndex
    );
    this.currentScene.rightInterviewer.setTexture(
      "interviewer" + this.currentRightInterviewerIndex
    );
    this.currentScene.leftThumb.setTexture("cvThumb" + this.currentLeftInterviewerIndex);

    this.currentScene.rightThumb.setTexture(
      "cvThumb" + this.currentRightInterviewerIndex
    );
  }

  // ========================================== preload and create =====================================

  proloadImageAssets() {
    if (gameVM.language == null) {
      this.removeTextures();
      this.currentScene.load.image("background_scene3", background);
      this.currentScene.load.image("timeFont", timeFont);
      this.currentScene.load.image("scoreFont", scoreFont);
      this.currentScene.load.image("timerBar", timerBar);
      this.currentScene.load.image("gameScorebar", gameScorebar);
      this.currentScene.load.image("timeProgressbar", timeProgressbar);
      this.currentScene.load.image("goToInstruction", goToInstruction);
      this.currentScene.load.image("instruction", instruction);
      this.currentScene.load.image("understand", understand);
      this.currentScene.load.image("leftDoor", leftDoor);
      this.currentScene.load.image("rightDoor", rightDoor);
      this.currentScene.load.image("boss", boss);
      this.currentScene.load.image("boss_correct", boss_correct);
      this.currentScene.load.image("boss_incorrect", boss_incorrect);
      this.currentScene.load.image("boss_incorrectExit", boss_incorrectExit);
      this.currentScene.load.image("boss2", boss2);
      this.currentScene.load.image("boss2_correct", boss2_correct);
      this.currentScene.load.image("boss2_incorrect", boss2_incorrect);
      this.currentScene.load.image("boss2_incorrectExit", boss2_incorrectExit);
      this.currentScene.load.image("message_needExperience", message_needExperience);
      this.currentScene.load.image("message_needIntern", message_needIntern);
      this.currentScene.load.image("message_correct", message_correct);
      this.currentScene.load.image("message_incorrect", message_incorrect);
      this.currentScene.load.image("message_incorrectExit", message_incorrectExit);
      this.currentScene.load.image("interviewer0", interviewer0);
      this.currentScene.load.image("interviewer1", interviewer1);
      this.currentScene.load.image("interviewer2", interviewer2);
      this.currentScene.load.image("interviewer3", interviewer3);
      this.currentScene.load.image("interviewer4", interviewer4);

      this.currentScene.load.image("interviewer5", interviewer5);
      this.currentScene.load.image("interviewer6", interviewer6);
      this.currentScene.load.image("interviewer7", interviewer7);
      this.currentScene.load.image("interviewer8", interviewer8);
      this.currentScene.load.image("interviewer9", interviewer9);

      this.currentScene.load.image("interviewer10", interviewer10);
      this.currentScene.load.image("interviewer11", interviewer11);
      this.currentScene.load.image("interviewer12", interviewer12);
      this.currentScene.load.image("interviewer13", interviewer13);
      this.currentScene.load.image("interviewer14", interviewer14);

      this.currentScene.load.image("interviewer15", interviewer15);
      this.currentScene.load.image("interviewer16", interviewer16);
      this.currentScene.load.image("interviewer17", interviewer17);
      this.currentScene.load.image("interviewer18", interviewer18);
      this.currentScene.load.image("interviewer19", interviewer19);

      this.currentScene.load.image("cvCover", cvCover);
      this.currentScene.load.image("cvThumb0", cvThumb0);
      this.currentScene.load.image("cvThumb1", cvThumb1);
      this.currentScene.load.image("cvThumb2", cvThumb2);
      this.currentScene.load.image("cvThumb3", cvThumb3);
      this.currentScene.load.image("cvThumb4", cvThumb4);

      this.currentScene.load.image("cvThumb5", cvThumb5);
      this.currentScene.load.image("cvThumb6", cvThumb6);
      this.currentScene.load.image("cvThumb7", cvThumb7);
      this.currentScene.load.image("cvThumb8", cvThumb8);
      this.currentScene.load.image("cvThumb9", cvThumb9);

      this.currentScene.load.image("cvThumb10", cvThumb10);
      this.currentScene.load.image("cvThumb11", cvThumb11);
      this.currentScene.load.image("cvThumb12", cvThumb12);
      this.currentScene.load.image("cvThumb13", cvThumb13);
      this.currentScene.load.image("cvThumb14", cvThumb14);

      this.currentScene.load.image("cvThumb15", cvThumb15);
      this.currentScene.load.image("cvThumb16", cvThumb16);
      this.currentScene.load.image("cvThumb17", cvThumb17);
      this.currentScene.load.image("cvThumb18", cvThumb18);
      this.currentScene.load.image("cvThumb19", cvThumb19);

      this.currentScene.load.image("exit", exit);
      this.currentScene.load.image("doorHint", doorHint);
      this.currentScene.load.image("bossBackground", bossBackground);
      this.currentScene.load.image("addScore", addScore);
      this.currentScene.load.image("minusScore", minusScore);
      this.currentScene.load.image("correctDoor", correctDoor);
      this.currentScene.load.image("incorrectDoor", incorrectDoor);
      this.currentScene.load.image("leftDoorOpen", leftDoorOpen);
      this.currentScene.load.image("rightDoorOpen", rightDoorOpen);
      this.currentScene.load.image("interviewButton", interviewButton);
      this.currentScene.load.image("quitButton", quitButton);
      this.currentScene.load.image("gameinfoInGame", gameinfoInGame);
    } else if (gameVM.language == "EN") {
      this.removeTextures();
      this.currentScene.load.image("background_scene3", backgroundEN);
      this.currentScene.load.image("timeFont", timeFontEN);
      this.currentScene.load.image("scoreFont", scoreFontEN);
      this.currentScene.load.image("timerBar", timerBarEN);
      this.currentScene.load.image("gameScorebar", gameScorebarEN);
      this.currentScene.load.image("timeProgressbar", timeProgressbarEN);
      this.currentScene.load.image("goToInstruction", goToInstructionEN);
      this.currentScene.load.image("instruction", instructionEN);
      this.currentScene.load.image("understand", understandEN);
      this.currentScene.load.image("leftDoor", leftDoorEN);
      this.currentScene.load.image("rightDoor", rightDoorEN);
      this.currentScene.load.image("boss", bossEN);
      this.currentScene.load.image("boss_correct", boss_correctEN);
      this.currentScene.load.image("boss_incorrect", boss_incorrectEN);
      this.currentScene.load.image("boss_incorrectExit", boss_incorrectExitEN);
      this.currentScene.load.image("boss2", boss2EN);
      this.currentScene.load.image("boss2_correct", boss2_correctEN);
      this.currentScene.load.image("boss2_incorrect", boss2_incorrectEN);
      this.currentScene.load.image("boss2_incorrectExit", boss2_incorrectExitEN);
      this.currentScene.load.image("message_needExperience", message_needExperienceEN);
      this.currentScene.load.image("message_needIntern", message_needInternEN);
      this.currentScene.load.image("message_correct", message_correctEN);
      this.currentScene.load.image("message_incorrect", message_incorrectEN);
      this.currentScene.load.image("message_incorrectExit", message_incorrectExitEN);
      this.currentScene.load.image("interviewer0", interviewer0EN);
      this.currentScene.load.image("interviewer1", interviewer1EN);
      this.currentScene.load.image("interviewer2", interviewer2EN);
      this.currentScene.load.image("interviewer3", interviewer3EN);
      this.currentScene.load.image("interviewer4", interviewer4EN);

      this.currentScene.load.image("interviewer5", interviewer5EN);
      this.currentScene.load.image("interviewer6", interviewer6EN);
      this.currentScene.load.image("interviewer7", interviewer7EN);
      this.currentScene.load.image("interviewer8", interviewer8EN);
      this.currentScene.load.image("interviewer9", interviewer9EN);

      this.currentScene.load.image("interviewer10", interviewer10EN);
      this.currentScene.load.image("interviewer11", interviewer11EN);
      this.currentScene.load.image("interviewer12", interviewer12EN);
      this.currentScene.load.image("interviewer13", interviewer13EN);
      this.currentScene.load.image("interviewer14", interviewer14EN);

      this.currentScene.load.image("interviewer15", interviewer15EN);
      this.currentScene.load.image("interviewer16", interviewer16EN);
      this.currentScene.load.image("interviewer17", interviewer17EN);
      this.currentScene.load.image("interviewer18", interviewer18EN);
      this.currentScene.load.image("interviewer19", interviewer19EN);

      this.currentScene.load.image("cvCover", cvCoverEN);
      this.currentScene.load.image("cvThumb0", cvThumb0EN);
      this.currentScene.load.image("cvThumb1", cvThumb1EN);
      this.currentScene.load.image("cvThumb2", cvThumb2EN);
      this.currentScene.load.image("cvThumb3", cvThumb3EN);
      this.currentScene.load.image("cvThumb4", cvThumb4EN);

      this.currentScene.load.image("cvThumb5", cvThumb5EN);
      this.currentScene.load.image("cvThumb6", cvThumb6EN);
      this.currentScene.load.image("cvThumb7", cvThumb7EN);
      this.currentScene.load.image("cvThumb8", cvThumb8EN);
      this.currentScene.load.image("cvThumb9", cvThumb9EN);

      this.currentScene.load.image("cvThumb10", cvThumb10EN);
      this.currentScene.load.image("cvThumb11", cvThumb11EN);
      this.currentScene.load.image("cvThumb12", cvThumb12EN);
      this.currentScene.load.image("cvThumb13", cvThumb13EN);
      this.currentScene.load.image("cvThumb14", cvThumb14EN);

      this.currentScene.load.image("cvThumb15", cvThumb15EN);
      this.currentScene.load.image("cvThumb16", cvThumb16EN);
      this.currentScene.load.image("cvThumb17", cvThumb17EN);
      this.currentScene.load.image("cvThumb18", cvThumb18EN);
      this.currentScene.load.image("cvThumb19", cvThumb19EN);

      this.currentScene.load.image("exit", exitEN);
      this.currentScene.load.image("doorHint", doorHintEN);
      this.currentScene.load.image("bossBackground", bossBackgroundEN);
      this.currentScene.load.image("addScore", addScoreEN);
      this.currentScene.load.image("minusScore", minusScoreEN);
      this.currentScene.load.image("correctDoor", correctDoorEN);
      this.currentScene.load.image("incorrectDoor", incorrectDoorEN);
      this.currentScene.load.image("leftDoorOpen", leftDoorOpenEN);
      this.currentScene.load.image("rightDoorOpen", rightDoorOpenEN);
      this.currentScene.load.image("interviewButton", interviewButtonEN);
      this.currentScene.load.image("quitButton", quitButtonEN);
      this.currentScene.load.image("gameinfoInGame", gameinfoInGameEN);
    } else if (gameVM.language == "SC") {
      this.removeTextures();
      this.currentScene.load.image("background_scene3", backgroundSC);
      this.currentScene.load.image("timeFont", timeFontSC);
      this.currentScene.load.image("scoreFont", scoreFontSC);
      this.currentScene.load.image("timerBar", timerBarSC);
      this.currentScene.load.image("gameScorebar", gameScorebarSC);
      this.currentScene.load.image("timeProgressbar", timeProgressbarSC);
      this.currentScene.load.image("goToInstruction", goToInstructionSC);
      this.currentScene.load.image("instruction", instructionSC);
      this.currentScene.load.image("understand", understandSC);
      this.currentScene.load.image("leftDoor", leftDoorSC);
      this.currentScene.load.image("rightDoor", rightDoorSC);
      this.currentScene.load.image("boss", bossSC);
      this.currentScene.load.image("boss_correct", boss_correctSC);
      this.currentScene.load.image("boss_incorrect", boss_incorrectSC);
      this.currentScene.load.image("boss_incorrectExit", boss_incorrectExitSC);
      this.currentScene.load.image("boss2", boss2SC);
      this.currentScene.load.image("boss2_correct", boss2_correctSC);
      this.currentScene.load.image("boss2_incorrect", boss2_incorrectSC);
      this.currentScene.load.image("boss2_incorrectExit", boss2_incorrectExitSC);
      this.currentScene.load.image("message_needExperience", message_needExperienceSC);
      this.currentScene.load.image("message_needIntern", message_needInternSC);
      this.currentScene.load.image("message_correct", message_correctSC);
      this.currentScene.load.image("message_incorrect", message_incorrectSC);
      this.currentScene.load.image("message_incorrectExit", message_incorrectExitSC);
      this.currentScene.load.image("interviewer0", interviewer0SC);
      this.currentScene.load.image("interviewer1", interviewer1SC);
      this.currentScene.load.image("interviewer2", interviewer2SC);
      this.currentScene.load.image("interviewer3", interviewer3SC);
      this.currentScene.load.image("interviewer4", interviewer4SC);

      this.currentScene.load.image("interviewer5", interviewer5SC);
      this.currentScene.load.image("interviewer6", interviewer6SC);
      this.currentScene.load.image("interviewer7", interviewer7SC);
      this.currentScene.load.image("interviewer8", interviewer8SC);
      this.currentScene.load.image("interviewer9", interviewer9SC);

      this.currentScene.load.image("interviewer10", interviewer10SC);
      this.currentScene.load.image("interviewer11", interviewer11SC);
      this.currentScene.load.image("interviewer12", interviewer12SC);
      this.currentScene.load.image("interviewer13", interviewer13SC);
      this.currentScene.load.image("interviewer14", interviewer14SC);

      this.currentScene.load.image("interviewer15", interviewer15SC);
      this.currentScene.load.image("interviewer16", interviewer16SC);
      this.currentScene.load.image("interviewer17", interviewer17SC);
      this.currentScene.load.image("interviewer18", interviewer18SC);
      this.currentScene.load.image("interviewer19", interviewer19SC);

      this.currentScene.load.image("cvCover", cvCoverSC);
      this.currentScene.load.image("cvThumb0", cvThumb0SC);
      this.currentScene.load.image("cvThumb1", cvThumb1SC);
      this.currentScene.load.image("cvThumb2", cvThumb2SC);
      this.currentScene.load.image("cvThumb3", cvThumb3SC);
      this.currentScene.load.image("cvThumb4", cvThumb4SC);

      this.currentScene.load.image("cvThumb5", cvThumb5SC);
      this.currentScene.load.image("cvThumb6", cvThumb6SC);
      this.currentScene.load.image("cvThumb7", cvThumb7SC);
      this.currentScene.load.image("cvThumb8", cvThumb8SC);
      this.currentScene.load.image("cvThumb9", cvThumb9SC);

      this.currentScene.load.image("cvThumb10", cvThumb10SC);
      this.currentScene.load.image("cvThumb11", cvThumb11SC);
      this.currentScene.load.image("cvThumb12", cvThumb12SC);
      this.currentScene.load.image("cvThumb13", cvThumb13SC);
      this.currentScene.load.image("cvThumb14", cvThumb14SC);

      this.currentScene.load.image("cvThumb15", cvThumb15SC);
      this.currentScene.load.image("cvThumb16", cvThumb16SC);
      this.currentScene.load.image("cvThumb17", cvThumb17SC);
      this.currentScene.load.image("cvThumb18", cvThumb18SC);
      this.currentScene.load.image("cvThumb19", cvThumb19SC);

      this.currentScene.load.image("exit", exitSC);
      this.currentScene.load.image("doorHint", doorHintSC);
      this.currentScene.load.image("bossBackground", bossBackgroundSC);
      this.currentScene.load.image("addScore", addScoreSC);
      this.currentScene.load.image("minusScore", minusScoreSC);
      this.currentScene.load.image("correctDoor", correctDoorSC);
      this.currentScene.load.image("incorrectDoor", incorrectDoorSC);
      this.currentScene.load.image("leftDoorOpen", leftDoorOpenSC);
      this.currentScene.load.image("rightDoorOpen", rightDoorOpenSC);
      this.currentScene.load.image("interviewButton", interviewButtonSC);
      this.currentScene.load.image("quitButton", quitButtonSC);
      this.currentScene.load.image("gameinfoInGame", gameinfoInGameSC);
    }
  }

  addImageAssets() {
    this.currentScene.add.image(0, 0, "background_scene3").setOrigin(0, 0);
    this.currentScene.add.image(gameVM.language == "EN" ? 86 : 80, 62, "timeFont");
    this.currentScene.add.image(365, 62, "timerBar");
    this.currentScene.add.image(80, 149, "scoreFont");
    this.currentScene.add.image(268, 149, "gameScorebar");
    this.currentScene.timeProgressbar = this.currentScene.add
      .image(190, 42, "timeProgressbar")
      .setOrigin(0, 0);

    this.currentScene.doorHintLeft = this.currentScene.add.image(
      0.5525 * 1920,
      0.375 * 1020,
      "doorHint"
    );
    this.currentScene.doorHintRight = this.currentScene.add.image(
      0.7735 * 1920,
      0.375 * 1020,
      "doorHint"
    );

    this.currentScene.leftDoorCorrectIndicator = this.currentScene.add.image(
      0.55 * 1920,
      387,
      "correctDoor"
    );
    this.currentScene.leftDoorIncorrectIndicator = this.currentScene.add.image(
      0.55 * 1920,
      387,
      "incorrectDoor"
    );

    this.currentScene.rightDoorCorrectIndicator = this.currentScene.add.image(
      0.775 * 1920,
      387,
      "correctDoor"
    );
    this.currentScene.rightDoorIncorrectIndicator = this.currentScene.add.image(
      0.775 * 1920,
      387,
      "incorrectDoor"
    );

    this.currentScene.leftDoorClosed = this.currentScene.add.image(
      0.55 * 1920,
      387,
      "leftDoor"
    );
    this.currentScene.rightDoorClosed = this.currentScene.add.image(
      0.775 * 1920,
      387,
      "rightDoor"
    );

    this.currentScene.leftDoorOpen = this.currentScene.add.image(
      1041,
      392,
      "leftDoorOpen"
    );
    this.currentScene.rightDoorOpen = this.currentScene.add.image(
      1451,
      363,
      "rightDoorOpen"
    );

    this.leftInterviewerOriginalPosition = [200, 0.5 * 1080];

    this.currentScene.leftInterviewer = this.currentScene.add.image(
      ...this.leftInterviewerOriginalPosition,
      ""
    );

    this.currentScene.leftCV = this.currentScene.add.container(0, 0);

    this.currentScene.leftcvCover = this.currentScene.add
      .image(30, 1080, "cvCover")
      .setOrigin(0, 1);
    this.currentScene.leftThumb = this.currentScene.add
      .image(72, 0.6 * 1080, "cvThumb" + this.currentLeftInterviewerIndex)
      .setOrigin(0, 0);
    this.currentScene.leftExit = this.currentScene.add
      .image(-20, 1080, "exit")
      .setOrigin(0, 1)
      .setInteractive({ cursor: "pointer" });

    this.currentScene.leftInterview = this.currentScene.add
      .image(295, 1080, "interviewButton")
      .setOrigin(0, 1)
      .setInteractive({ cursor: "pointer" });

    this.rightInterviewerOriginalPosition = [690, 0.5 * 1080];

    this.currentScene.rightInterviewer = this.currentScene.add.image(
      ...this.rightInterviewerOriginalPosition,
      ""
    );

    this.currentScene.rightCvCover = this.currentScene.add
      .image(540 + 30, 1080, "cvCover")
      .setOrigin(0, 1);
    this.currentScene.rightThumb = this.currentScene.add
      .image(550 + 62, 0.6 * 1080, "cvThumb" + this.currentRightInterviewerIndex)
      .setOrigin(0, 0);
    this.currentScene.rightCV = this.currentScene.add.container(0, 0);
    this.currentScene.rightExit = this.currentScene.add
      .image(520, 1080, "exit")
      .setOrigin(0, 1)
      .setInteractive({ cursor: "pointer" });

    this.currentScene.rightInterview = this.currentScene.add
      .image(850, 1080, "interviewButton")
      .setOrigin(0, 1)
      .setInteractive({ cursor: "pointer" });

    this.currentScene.leftCV.add([
      this.currentScene.leftcvCover,
      this.currentScene.leftThumb,
      this.currentScene.leftExit,
      this.currentScene.leftInterview,
    ]);

    this.currentScene.rightCV.add([
      this.currentScene.rightCvCover,
      this.currentScene.rightThumb,
      this.currentScene.rightExit,
      this.currentScene.rightInterview,
    ]);

    this.createCVText();

    this.currentScene.goToInstructionButton = this.currentScene.add
      .image(0.25 * 1920, 150, "goToInstruction")
      .setInteractive({ cursor: "pointer" });

    this.currentScene.goToInstructionButton.on("pointerup", () => {
      this.openInstruction();
    });

    this.currentScene.leftHitArea = new Phaser.Geom.Rectangle(
      30,
      300,
      this.currentScene.rightCvCover.width,
      1080 - 300
    );
    // this.currentScene.leftCV.setInteractive({
    //   hitArea: this.currentScene.leftHitArea,
    //   hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    //   cursor: "pointer"
    // });

    this.currentScene.rightHitArea = new Phaser.Geom.Rectangle(
      566,
      300,
      this.currentScene.rightCvCover.width,
      1080 - 300
    );
    // this.currentScene.rightCV.setInteractive({
    //   hitArea: this.currentScene.rightHitArea,
    //   hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    //   cursor: "pointer"
    // });

    this.currentScene.bossBackground = this.currentScene.add
      .image(1920, 1080, "bossBackground")
      .setOrigin(1, 1);
    this.currentScene.boss = this.currentScene.add
      .image(1920, 1080, "boss")
      .setOrigin(1, 1);
    this.currentScene.boss_correct = this.currentScene.add
      .image(1920, 1080, "boss_correct")
      .setOrigin(1, 1);
    this.currentScene.boss_incorrect = this.currentScene.add
      .image(1920, 1080, "boss_incorrect")
      .setOrigin(1, 1);
    this.currentScene.boss_incorrectExit = this.currentScene.add
      .image(1920, 1080, "boss_incorrectExit")
      .setOrigin(1, 1);

    this.currentScene.boss2 = this.currentScene.add
      .image(1920, 1080, "boss2")
      .setOrigin(0.92, 1);
    this.currentScene.boss2_correct = this.currentScene.add
      .image(1920, 1080, "boss2_correct")
      .setOrigin(0.92, 1);
    this.currentScene.boss2_incorrect = this.currentScene.add
      .image(1920, 1080, "boss2_incorrect")
      .setOrigin(0.92, 1);
    this.currentScene.boss2_incorrectExit = this.currentScene.add
      .image(1920, 1080, "boss2_incorrectExit")
      .setOrigin(0.92, 1);

    this.currentScene.message_needExperience = this.currentScene.add
      .image(1620, 780, "message_needExperience")
      .setOrigin(1, 1);
    this.currentScene.message_needIntern = this.currentScene.add
      .image(1620, 780, "message_needIntern")
      .setOrigin(1, 1);
    this.currentScene.message_correct = this.currentScene.add
      .image(1620, 780, "message_correct")
      .setOrigin(1, 1);
    this.currentScene.message_incorrect = this.currentScene.add
      .image(1620, 780, "message_incorrect")
      .setOrigin(1, 1);
    this.currentScene.message_incorrectExit = this.currentScene.add
      .image(1620, 780, "message_incorrectExit")
      .setOrigin(1, 1);
    this.currentScene.quitButton = this.currentScene.add
      .image(0.934 * 1920, 60, "quitButton")
      .setInteractive({ cursor: "pointer" });

    this.currentScene.scoreText = this.currentScene.add
      .text(264, 147, this.score, {
        fontSize: "70px",
        fill: "#374631",
        fontFamily: "DFZongYiBold-B5",
      })
      .setScale(1, 0.6)
      .setOrigin(0.5, 0.5);
  }

  removeTextures() {
    const imgKeys = [
      "background_scene3",
      "timeFont",
      "scoreFont",
      "timerBar",
      "gameScorebar",
      "timeProgressbar",
      "goToInstruction",
      "instruction",
      "understand",
      "leftDoor",
      "rightDoor",
      "boss",
      "boss_correct",
      "boss_incorrect",
      "boss_incorrectExit",
      "boss2",
      "boss2_correct",
      "boss2_incorrect",
      "boss2_incorrectExit",
      "message_needExperience",
      "message_needIntern",
      "message_correct",
      "message_incorrect",
      "message_incorrectExit",
      "interviewer0",
      "interviewer1",
      "interviewer2",
      "interviewer3",
      "interviewer4",
      "cvCover",
      "cvThumb0",
      "cvThumb1",
      "cvThumb2",
      "cvThumb3",
      "cvThumb4",
      "exit",
      "doorHint",
      "bossBackground",
      "addScore",
      "minusScore",
      "correctDoor",
      "incorrectDoor",
      "leftDoorOpen",
      "rightDoorOpen",
      "interviewButton",
      "quitButton",
      "gameinfoInGame",
    ];

    for (let key of imgKeys) {
      this.currentScene.textures.remove(key);
    }
  }
}
